import S360WidgetBlock from "root/s360components/LearningJournal/S360WidgetBlock";
import BootstrapRow from "root/ReactHookForm/ui/BootstrapRow";
import BootstrapCol from "root/ReactHookForm/ui/BootstrapCol";
import ReportWidget from "root/s360components/Reports/ReportWidget";
import S360WidgetContainer from "root/s360components/LearningJournal/S360WidgetContainer";
import React from "react";


const AttendanceReportsPage = ({home, rval, menu}) =>
{

    return (
            <S360WidgetContainer style={{minHeight: '500px'}}>
                <S360WidgetBlock title=''>
                    <BootstrapRow>
                        <BootstrapCol width={2}>
                            <ReportWidget heading='Lunch Reports' iconClass='icon-learning' title='Lunch Reports' reportPage='Lunch' imageName='journal.svg' page='react_form_lunch_report' basePage={home} rval={rval} menu={menu}/>
                        </BootstrapCol>
                    </BootstrapRow>
                </S360WidgetBlock>
            </S360WidgetContainer>
    )
}

export default AttendanceReportsPage;